import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_rn6fyv9g7w: FaireBrandEntity = {
  token: "b_rn6fyv9g7w",
  type: "brand",
  name: "All Good Home & Body",
  avatarUrl:
    "https://cdn.faire.com/fastly/8d081fdf7f25161f0e6e9707758031198f7df035fe7a363c5d3792ae03289127.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/ed47d2b77ae8667efd382328eaba36db1930d7c88f6961e09b33e6a09583df77.png",
  logoUrl:
    "https://cdn.faire.com/fastly/8d081fdf7f25161f0e6e9707758031198f7df035fe7a363c5d3792ae03289127.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ed47d2b77ae8667efd382328eaba36db1930d7c88f6961e09b33e6a09583df77.png",
  location: "French Lick, USA",
  minimumOrderDollars: 0,
  rating: 5,
  reviewCount: 3,
  isTopShop: true,
  isInsider: true,
  description:
    "All Good Home & Body was created from a deeply personal season. After losing my dad in October, I found myself searching for something grounding — a way to process grief while creating something meaningful. What started as a small outlet quickly became a brand rooted in calm, comfort, and intention.\n\nThe name “All Good” comes from something my dad always said — “it’s all good,” even in the hardest moments. That perspective now lives at the heart of everything I make.\n\nEach product is handcrafted in small batches using clean, thoughtfully chosen ingredients and essential oil–based blends. From lotion bars and roll-on perfumes to reed diffusers and shower steamers, every piece is designed to bring a sense of calm into everyday routines.\n\nAll Good is built around simple, giftable products that feel personal, comforting, and easy to incorporate into daily life. Whether it’s a quiet moment at the end of the day or a thoughtful gift for someone else, the goal is always the same — to create small moments of calm, wherever you are.\n\nHandcrafted in Southern Indiana, All Good is more than a product line — it’s a reminder that even in the hardest seasons, there is still good to be found.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:18.017Z",
    importedBy: "entity-db-cli",
  },
};
